import React, { FC } from 'react'
import * as css from './HierarchyCell.css'

const HierarchyCell: FC = ({ children, ...props }) => {
  return (
    <div className={css['cell']} {...props}>
      {children}
    </div>
  )
}

export default HierarchyCell
